import React, { Fragment, useContext, useEffect, useState } from 'react';
import {getPayment,updatePayment} from '../../services/catalogServices';
import Toast from '../../helpers/Toast';
import { AuthContext } from '../../../context/Auth.context';
import {useNavigate, useParams} from 'react-router-dom';

const Payment = () => {
    let navigate = useNavigate();
    const [payment, setPayment] = useState({
        id: null,
        name: null,
        active: null,
        created_at: null,
        updated_at: null,
        count_for_cut_withdraw: null
    });
    
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [list, setList] = useState([]);
    const {state,CheckResponse } = useContext(AuthContext);
    const {id} = useParams();

    const showToast = (t,d,tt) => {
        setList([...list, {
            id: Math.floor((Math.random() * 101) + 1),
            title: t,
            description: d,
            type: tt
        }]);
    }

    useEffect(() => {
        getPayment(state.auth,id).then(data => {
            CheckResponse(data);
            if(data.code == 200){
                setPayment(data.payment);
            }
            setLoading(false);
          });
    }, []);

    const onSubmit = (e) => {
        e.preventDefault();
        setSaving(true);
        updatePayment(state.auth,payment).then(data => {
            CheckResponse(data);
            if(data.code == 200){
                showToast('Hecho!','Guardado con exito!','success');
            }else{
                showToast('Oops!','Algo salio mal!','danger');
            }
            setSaving(false);
          });
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-sm-12">
                    <h1>Metodo De Pago </h1>
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-sm-2">
                    <div className="d-grid gap-2">
                        <button onClick={() =>{navigate(-1)}} className={"btn btn-secondary mt-2"}><i className="bi bi-arrow-90deg-left"></i></button>
                    </div>
                </div>
            </div>
            {!loading && <div className="row">
                <div className="col-sm-12">
                    <Toast 
                        toastList={list}
                    />
                    <form name="loginForm" onSubmit={onSubmit}>
                        <div className="row">
                            <div className="col-sm-4">
                                <label className="form-label">Nombre</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="name"
                                    id="name"
                                    onChange={e => setPayment({ ...payment, name: e.target.value })}
                                    value={payment.name}
                                    placeholder="Nombre"
                                />
                            </div>
                            <div className="col-sm-4">
                                    <label className="form-label">Contar para el retiro del corte?</label>
                                    <div className="form-check form-switch">
                                        <input onChange={e => setPayment({ ...payment, count_for_cut_withdraw: !payment.count_for_cut_withdraw })} className="form-check-input" type="checkbox" checked={payment.count_for_cut_withdraw ? 'checked' : ''}></input>
                                        <label className="form-check-label">{payment.count_for_cut_withdraw ? 'Si' : 'No'}</label>
                                    </div>
                            </div>
                            <div className="col-sm-4">
                                    <label className="form-label">Activo</label>
                                    <div className="form-check form-switch">
                                        <input onChange={e => setPayment({ ...payment, active: !payment.active })} className="form-check-input" type="checkbox" checked={payment.active ? 'checked' : ''}></input>
                                        <label className="form-check-label">{payment.active ? 'Si' : 'No'}</label>
                                    </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 mt-5">
                                {!saving &&  <div className="d-grid gap-2 col-6 mx-auto">
                                    <button className="btn btn-success" type="submit"><i className="bi bi-save"></i> Guardar</button>
                                </div>}
                                {saving &&  <div className="d-flex justify-content-center mt-4">
                                    <div className="spinner-border text-primary" style={{"width" : "5rem", "height": "5rem"}} role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </form>
                </div>
            </div>}

            {loading &&  <div className="d-flex justify-content-center mt-4">
                            <div className="spinner-border text-primary" style={{"width" : "8rem", "height": "8rem"}} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>}

                    
            
        </Fragment>
    );
}

export default Payment;